import { render } from "./CardsBills.vue?vue&type=template&id=7c81702d&scoped=true"
import script from "./CardsBills.vue?vue&type=script&lang=js"
export * from "./CardsBills.vue?vue&type=script&lang=js"

import "./CardsBills.vue?vue&type=style&index=0&id=7c81702d&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend_tr\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c81702d"]])

export default __exports__